import { CustomCellRendererProps } from "ag-grid-react";
import PhoneLink from "../components/PhoneLink";

/**
 * Grid cell renderer for phone columns. Stops propagation so dialing a number
 * doesn't also trigger the row's click handler.
 */
const PhoneCellRenderer = (params: CustomCellRendererProps) => (
  <PhoneLink phone={params.value} stopPropagation />
);

export default PhoneCellRenderer;
